import Dialog from 'components/ReusableComponents/Dialog'

import styles from './DialogWithCloseButton.module.scss'

const DialogWithCloseButton = ({ title, children, handleClose }) => (
  <Dialog>
    <div className={styles.dialog}>
      <div className={styles.header}>
        <h1>{title}</h1>
        <button className={styles.close} onClick={handleClose}></button>
      </div>
      <div className={styles.container}>{children}</div>
    </div>
  </Dialog>
)

export default DialogWithCloseButton
